module.exports = __webpack_public_path__ + "media/images/official/special_workcation-036b4d0e81674901ffa88d9ffdef4b2c.jpg";